import React,{Component} from 'react';
import {reduxForm} from 'redux-form';
import * as actions from '../../actions';
import { Link, browserHistory} from 'react-router';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login';

import $ from 'jquery';
const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';

const responseGoogle = (response) => {
   console.log(response);
}

// const responseFacebook = (response) => {
  // console.log(response);
// }

class Registration extends Component{
  constructor(props){
    super(props);
    this.state={
      status: '',
      msg: '',
      name: '',
      email:'',
      picture: '',
      id:'',
      accessToken:'',
      signedRequest: '',
      userID: '',
      expiresIn: '',
      err_mobile: '',

      g_id: '',
      g_name: '',
      g_fname: '',
      g_picture: '',
      g_email: '',
      mobile:'',
      animate_status:false,
      animate_social_status:false,
      social_text:true,
      sign_text:'SIGN IN OR REGISTER',
      placeholder_text:'Enter your mobile number',
    };
    this.handleFormSubmit=this.handleFormSubmit.bind(this);
    this.getFbData=this.getFbData.bind(this);
    this.getGoogleData=this.getGoogleData.bind(this);
    this.mobileChange=this.mobileChange.bind(this);
    
    this.animateTop=this.animateTop.bind(this);
    this.animateBottom=this.animateBottom.bind(this);
    this.animateTop_Social=this.animateTop_Social.bind(this);
    this.animateBottom_Socail=this.animateBottom_Social.bind(this);
  }
  animateTop()
  {
    this.setState({
      animate_status:true,
      animate_social_status:false,
      social_text:false,
      sign_text:'Enter your mobile number',
      placeholder_text:'Mobile Number',
    });
  }
  animateBottom()
  {
    this.setState({
        animate_status:false,
        social_text:true,
        sign_text:'SIGN IN OR REGISTER',
        placeholder_text:'Enter your mobile number',
    });
  }
  animateTop_Social()
  {
      this.setState({
        // animate_status:true,
        animate_social_status:true,
        social_text:true,
      });
  }
  animateBottom_Social()
  {
      this.setState({
        animate_social_status:false,
      });
  }
  mobileChange(e)
  {
    var invalidChars = /[^0-9]/gi;
    if(invalidChars.test(this.refs.mobile.value))
    {
        var valid_number = this.refs.mobile.value.replace(invalidChars,"");
    }
    this.setState({
        mobile: valid_number,
    });
  }
  getFbData(res)
  {
    this.setState({
        name: res.name,
        email: res.email,
        id: res.id,
        userId: res.user_id,
        expiresIn: res.expiresIn,
        picture: res.picture.data.url,
    });
    var data1={from:'mobile_web',name:res.name,social_type: '1',email:res.email,device_id:localStorage.getItem('push_device_id'),version:'',platform:'',language:''};
    var data2=JSON.stringify(data1);
    $.ajax({
        method: 'post',
        data: {req: data2},
        url: baseUrl+'social_login',
        success: function(data){
          data= JSON.parse(data);
          if(data.status==='success' && data.page_source==='dashboard'){
            localStorage.setItem('token',data.token);
            localStorage.setItem('user_id',data.uid);
            localStorage.setItem('f_uid',data.uid);
            browserHistory.push('/');
          }
          else if(data.status ==='success' && data.page_source==='mobile_number'){
            localStorage.setItem('f_uid',data.uid);
            localStorage.setItem('f_email',data.email);
            localStorage.setItem('user_id',data.uid);
            browserHistory.push('/mobile');
          }
          else if(data.status === 'success' && data.page_source==="otp_screen"){
            localStorage.setItem('mobile_number',data.mobile);
            browserHistory.push('/mobile/verify_otp');
            window.location.reload();
          }
        },
        error: function(err){
          console.log(err);
        }
    });
  }
  getGoogleData(res)
  {
      this.setState({
          g_name: res.profileObj.name,
          g_email: res.profileObj.email,
          g_aname: res.profileObj.givenName,
          id: res.id,
          g_id: res.El,
          g_picture: res.profileObj.imageUrl,
      });
      var data1={from:'mobile_web',name: res.profileObj.name,social_type: '2',email:res.profileObj.email,device_id:localStorage.getItem('push_device_id'),version:'',platform:'',language:''};
      var data2=JSON.stringify(data1);
      $.ajax({
          method: 'post',
          data: {req: data2},
          url: baseUrl+'social_login',
          success: function(data){
            data= JSON.parse(data);
                if(data.status==='success' && data.page_source==='dashboard')
                {
                   localStorage.setItem('token',data.token);
                   localStorage.setItem('f_uid',data.uid);
                   localStorage.setItem('user_id',data.uid);
                   browserHistory.push('/');
                }
                else if(data.status ==='success' && data.page_source==='mobile_number')
                {
                   localStorage.setItem('f_uid',data.uid);
                   localStorage.setItem('f_email',data.email);
                   localStorage.setItem('user_id',data.uid);
                   browserHistory.push('/mobile');
                }
                else if(data.status === 'success' && data.page_source==="otp_screen")
                {
                   localStorage.setItem('mobile_number',data.mobile);
                   browserHistory.push('/mobile/verify_otp');
                   window.location.reload();
                }
           },
          error: function(err){
           
          }
      });
  }
  renderAlert()
  {
    if(this.props.errorMessage){
      return (
        <div className="error">
          <strong></strong>
            {this.props.errorMessage}
        </div>
      )
    }
  }
  componentWillReceiveProps(newProps)
  {
     if (newProps.formdata.status === 'success' && newProps.formdata.page === "otp")
     {
        localStorage.setItem('pwd',newProps.formdata.pwd);
        localStorage.setItem('mobile_number',newProps.formdata.mobile);
        browserHistory.push('/Otpverify');
     }
  }
  componentDidMount()
  {
    this.refs.mobile.focus();
    if(localStorage.token && localStorage.user_id)
    {
      browserHistory.push('/');
    }
  }
  handleFormSubmit(formProps)
  {
    this.props.OTPsent(formProps);
    this.setState({
      status: this.props.formdata.status
    });
  }
  render(){
        // $(window).scrollTop(0);
        const {handleSubmit,fields:{mobile}} = this.props;
        document.title ="AquaDeals Registration - You find,buy best deals by register with us";
        document.getElementsByTagName("META")[2].content="You find,buy best deals by register with us";
        $('document').ready(function(){
            // $('.back_icon').css('opacity',0);
            // $('.social_back_icon').css('opacity',0);
            // $('.social_login_items_blk').css('opacity',0);
            // $('.social_login_items_blk').hide();

        // $('.log_reg').on('click', function(){
        //     $('.log_reg').addClass('log_top');
        //     $(this).css('top','80px');
        //     $('.login_bg').css('background-image','none');
        //     $('.txt').attr("placeholder", "Mobile Number");
        //     $('.sign_in_title').text('Enter your mobile number');
        //     $('.mob_regbtn').show();
        //     $('.back_icon').css('opacity',1);
        //     // $('.mob_regbtn').css('opacity',1)
        //     // $('.social_login_header_blk').css('opacity',0);
        //     $('.social_login_header_blk').hide();
        // });
        // $('.log_reg').on('focusout',function(){
        //     $('.mob_regbtn').show();
        //     $('.back_icon').css('opacity',1);
        // })
        // $("#new_mob").on('keypress',function() {
        //     $('#submit').show();
        //     $('.back_icon').css('opacity',1);
        // });
        // $("#new_mob").on('change',function() {
        //     $('#submit').show();
        //     $('.back_icon').css('opacity',1);
        // });

        // $('.mob_regbtn').on('click',function(){
        //     $('.back_icon').css('opacity',1);
        // });

        // $(document.body).on('click', '.back_icon' ,function()
        // {
        //     $('.log_reg').removeClass('log_top');
        //     $('.login_bg').css('background-image','url(https://aquadeals.in/admin/assets/images/web_imgs/login_bg.png)');
        //     $('.mob_regbtn').hide();
        //     $('.back_icon').css('opacity',0);
        //     $('.sign_in_title').text('SIGN IN OR REGISTER');
        //     $('.txt').attr("placeholder", "Enter your mobile number");
        //     // $('.social_login_header_blk').css('opacity',1);
        //     $('.social_login_header_blk').show();
        // });
        
        // $('.social_login_header').on('click',function(){
        //       // $('.log_reg').addClass('log_top');
        //       // $('.social_login_items_blk').css('opacity',1);
        //       $('.social_login_items_blk').show();
        //       $('.login_bg').hide();
        //       $('.login_bg').css('background-image','none');
        //       $('.log_reg').hide();
        //       $('.social_back_icon').css('opacity',1);
        //       $('.social_login_header_blk').css('top','0px','position','relative',);
        // });
        // $('.social_back_icon').on('click',function()
        // {
        //     $('.login_bg').show();
        //     $('.log_reg').show();
        //     $('.log_reg').removeClass('log_top');
        //     $('.social_back_icon').css('opacity',0);
        //     // $('.social_login_items_blk').css('opacity',0);
        //     $('.social_login_items_blk').hide();
        //     $('.social_login_header_blk').css('top','75px');
        //     $('.login_bg').css('background-image','url(https://aquadeals.in/admin/assets/images/web_imgs/login_bg.png)');
        //     $('.mob_regbtn').hide();
        //     $('.social_login_header_blk').css('opacity',1);
        // })
    });
  return (
    <div className="mob_deals mob_login_page mob_new_login_page">
        {this.state.animate_social_status ? '' : 
        <div>
          <div className={this.state.animate_status ? 'login_bg bgnone' : 'login_bg'}>
              <Link to={'/home'} className="signin_homeicon"><i><img src="https://aquadeals.in/admin/assets/images/web_imgs/home1.png" alt="" /></i></Link>
                {this.state.animate_status ? <span className="back_icon" onClick={()=>this.animateBottom()}><i><img src="https://aquadeals.in/admin/assets/images/web_imgs/back_arrow.png" width="18px" alt="" /></i></span> : ''}
                <div className={this.state.animate_status ? 'log_reg log_top' : 'log_reg'}>
                  <h5 className="sign_in_title">{this.state.sign_text}</h5>
                  <form onSubmit={handleSubmit(this.handleFormSubmit.bind(this))} className="reg_page_new login_form"> 
                      <div> 
                          <label><i className="ind_flg"><img className="ind_flg_img" src={"https://aquadeals.in/admin/assets/icons/india.png"} alt="" /></i><span style={{fontFamily:'robotoregular',fontWeight:'normal'}}>+91</span></label>
                          <input {...mobile} type="text" className="txt" placeholder={this.state.placeholder_text} required maxLength={10} ref="mobile" id="new_mob" onClick={()=>this.animateTop()} />
                          <span className="highlight"></span>
                          <span className="bar"></span>
                          <span className="error_mobile">{mobile.touched && mobile.error ? mobile.error : ''}</span>
                      </div>
                      <div className="clr">&nbsp;</div>    
                      {this.state.animate_status ? 
                        <div style={{textAlign:'center'}}>
                            <button action="submit" id="submit" className="mob_regbtn">SUBMIT</button>
                        </div> : ''}
                  </form>
                </div>
              </div>
          </div> }
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          {!this.state.animate_status && !this.state.animate_social_status ? <div style={{width:'100%',borderBottom:'1px solid #ccc',marginBottom:'10px'}}>&nbsp;</div> : ''}
        <section className="social_login_header_blk container">
              <div style={{paddingTop:'5px'}}>
                 {this.state.animate_social_status ? <span className="social_back_icon" onClick={()=>this.animateBottom_Social()}><i><img src="https://aquadeals.in/admin/assets/images/web_imgs/back_arrow.png" width="18px" alt="" /></i></span>: ''}
                 {/*{this.state.social_text ? <h4 className="social_login_header" onClick={()=>this.animateTop_Social()}>Connect with social login</h4> : ''}*/}
                 {this.state.animate_social_status ?
                 <div className="social_login_items_blk">
                   <div className="social_login_item">
                    <Link to="/ab_login"><button type="button" className="ab-lgn-btn">
                      <span><img src={baseAssets+'icons/web_icons/ab-lgn.png'} alt="" width="30px" /></span>
                      <span className="social_login_text">AquaBrahma</span>
                    </button></Link>
                   </div>
                  <div className="social_login_item">
                    <FacebookLogin 
                          appId="1677330529233582"
                          textButton={<FbLogo />}
                          autoLoad={false}
                          fields="name,email,picture"
                          callback={this.getFbData}
                          cssClass="fb-lgn-btn"
                          >
                    </FacebookLogin>
                  </div>
                  <div className="social_login_item">
                    <GoogleLogin className="google-lgn-btn" 
                        clientId={'252840862313-6chaofdjgcq8b9e08gbmevj9pjo9atqe.apps.googleusercontent.com'}
                        onSuccess={this.getGoogleData}
                        onFailure={responseGoogle}
                        autoLoad={false}
                      >
                        <span><img src={baseAssets+"icons/web_icons/g-lgn.png" }alt=" " width="30px" /></span>
                        <span className="social_login_text">Google</span>
                      </GoogleLogin>
                  </div>
                </div>  : ''}
            </div>
            <div className="clr">&nbsp;</div>
            <div className="clr">&nbsp;</div>
        </section>
   </div>  
  );
 }
}





function validate(formProps){
const errors = {};

  const mobile_Pattern = /^([0-9]){10}$/;
    if (formProps.mobile && !mobile_Pattern.test(formProps.mobile)) 
    {
      errors.mobile = 'Enter valid mobile number';
    }
  return errors;
}

function mapStateToProps(state){
  return {
    errorMessage:state.auth.error,
    authenticated:state.auth.authenticated,
    formdata:state.auth.formdata
  };
}

export default reduxForm({
  form :'register',
  fields:['mobile'],
  validate:validate
},mapStateToProps,actions)(Registration);



class FbLogo extends Component{
  render(){
    return(
        <div>
            <span><img src={baseAssets+"icons/web_icons/fb-lgn.png"} width="30px" alt=" "/></span>
            <span className="social_login_text">Facebook</span>
        </div>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/Auth/Registration.js
 **/